export class UserNotAuthorizedError extends Error {
    constructor(m?: string) {
        if(!m) {
            m = 'User is not authorized';
        }
        super(m);
    }
}
